module.exports = __webpack_public_path__ + "img/db-4.67fff2b4.png";